import PingLunIcon from "@/assets/icons/lun.svg";
import { ReviewDetailItem, anonymousData } from "@/common-components-src/api/reviews/review.interface";
import { useTranslation } from "@/i18n/client";
import { useStores } from "@/models";
import { EXPOSURE_RECORD as REVIEW_DETAIL_EXPOSURE_RECORD, sendClickTrack as reviewDetailSendClickTrack } from "@/tracks/25347";
import cn from "clsx";
import { useEffect, useState } from "react";
import HelpfulButton from "./HelpfulButton";
import MenuOpts from "./menuOpts";
import styles from "./reviews.module.scss";

interface Props {
  skuId?: string;
  commentItem: ReviewDetailItem;
  pageType?: string;
  onRefresh?: () => void;
  onDeleteCallback?: () => void;
  onAnonymousChange?: (b: boolean, data: anonymousData) => void;
}

export default function CommentBottomDetailOpts({
  commentItem,
  skuId,
  pageType,
  onRefresh,
  onDeleteCallback,
  onAnonymousChange,
}: Props) {
  const {
    anonymousFlag,
    commentId,
    commentNum: outerCommentNum,
    currentIsUseful,
    usefulNum,
  } = commentItem || {};
  const { t } = useTranslation();
  const { commentOpstsStore } = useStores();
  const [commentNum, setCommentNum] = useState(outerCommentNum);
  const [isAnoymous, setIsAnonymouse] = useState<boolean>(anonymousFlag);

  const onAnonymous = (is: boolean, data: anonymousData) => {
    setIsAnonymouse(is);
    onAnonymousChange?.(is, data);
  };

  const onCommentChange = (newCommentId: string, newValue: number) => {
    if (newCommentId === commentId) {
      setCommentNum(newValue);
    }
  };

  commentOpstsStore.onCommentChange(onCommentChange);
  const [expConfig, setExpConfig] = useState<any>(null);
  useEffect(() => {
    const config = '{"useClick": false, "stay_duration": 0.6, "repeated":false, "area_rate": 0.01}'
    setExpConfig({
      help: { expTag: "exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Evaluate_CommentDetail_Card_Btn_Expo, data: { skuid: `${skuId}` || "-100", button_name: "1", commentId: `${commentId}` || "-100" }, config: config },
      comment: { expTag: "exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Evaluate_CommentDetail_Card_Btn_Expo, data: { skuid: `${skuId}` || "-100", button_name: "2", commentId: `${commentId}` || "-100" }, config: config },
      more: { expTag: "exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Evaluate_CommentDetail_Card_Btn_Expo, data: { skuid: `${skuId}` || "-100", button_name: "3", commentId: `${commentId}` || "-100" }, config: config },
      reply: { expTag: "exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Evaluate_CommentDetail_More_Layer_Expo, data: { skuid: `${skuId}` || "-100", title: "4", commentId: `${commentId}` || "-100" }, config: config },
      delete: { expTag: "exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Evaluate_CommentDetail_More_Layer_Expo, data: { skuid: `${skuId}` || "-100", title: "1", commentId: `${commentId}` || "-100" }, config: config },
      report: { expTag: "exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Evaluate_CommentDetail_Report_Win_Expo, data: { skuid: `${skuId}` || "-100", commentId: `${commentId}` }, config: config },
    })
  }, [pageType, commentId, skuId])

  return (
    <div className={styles.detailBasicButton}>
      {/* {isAnoymous && <span className={styles.anonymous}><AnonymouseIcon/>Anonymous</span>} */}
      {
        expConfig && <>
          <HelpfulButton
            data={{ currentIsHelp: currentIsUseful, commentId, helpfulNum: String(usefulNum) }}
            expConfig={expConfig}
            pageType={pageType}
          />
          <div className={styles.line}></div>
          <div className={styles.btn}
            exptag={expConfig?.comment?.expTag}
            data-exptag-json-param={JSON.stringify(expConfig?.comment?.data)}
            data-exptag-config={expConfig?.comment?.config}
            onClick={() => {
              switch (pageType) {
                case "reviewDetail":
                  // {"button_name":"1-helpful，2-comment，3-more","commentId":""}
                  reviewDetailSendClickTrack.Evaluate_CommentDetail_Card_Btn({ button_name: "2", commentId: `${commentId}` || "-100", skuid: `${skuId}` || "-100" })
                  break;

                default:
                  break;
              }
            }}
          >
            <PingLunIcon className={cn(styles.pinglunIcon, styles.mar)}></PingLunIcon>
            {`${t("dp.commentSection.comment")}${commentNum !== 0 ? "(" + commentNum + ")" : ""}`}
          </div>
          <div className={styles.line}></div>
          <MenuOpts
            anonymous={anonymousFlag}
            expConfig={expConfig}
            pageType={pageType}
            params={{ commentId, skuId }}
            onRefresh={onRefresh}
            onDeleteCallback={onDeleteCallback}
            onAnonymous={onAnonymous}
          />
        </>
      }
    </div>
  );
}
